<div class="welldone-card mb-3 text-center">
    <!-- Loading state while we finalise the payment -->
    <div class="welldone-card-header" *ngIf="loading">
        <div class="d-flex flex-column align-items-center gap-3 py-4">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Caricamento...</span>
            </div>
            <div>
                <h2 class="mb-1">Stiamo processando il tuo pagamento</h2>
                <p class="mb-0 text-muted">
                    Attendere qualche secondo, non chiudere questa pagina.<br/>
                    Ti reindirizzeremo automaticamente alla home.
                </p>
            </div>
        </div>
    </div>

    <!-- Final outcome -->
    <div class="welldone-card-header" *ngIf="!loading && success">
        <h2 class="step-title mb-3">
            <span class="gradient-text">Grazie!</span>
        </h2>
        <br/>
        Il pagamento verrà preso in carico a breve dal gestore del servizio.
        <br/>
        Riceverai una mail conferma sia nel caso in cui vada a buon fine, sia nel caso in cui si verifichi un problema.
    </div>

    <div class="welldone-card-header" *ngIf="!loading && !success">
        <h1 class="text-danger">Siamo spiacenti!</h1>
        <br/>
        Si è verificato un errore durante il pagamento. Ti invitiamo a riprovare più tardi.
    </div>
</div>
